var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "material-input",
        {
          staticClass: "form-group-material-no-label col-6",
          attrs: { value: _vm.selectedType },
        },
        [
          _c("radio-section", {
            attrs: {
              name: "selected-status",
              "container-class": "w-auto",
              options: _vm.typeOptions,
            },
            model: {
              value: _vm.selectedType,
              callback: function ($$v) {
                _vm.selectedType = $$v
              },
              expression: "selectedType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedType === "application-status"
        ? _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("select-filter", {
                attrs: {
                  name: "import-status-filter",
                  multiple: "",
                  "status-type": "filogixStatus",
                  label: _vm.$t("global.words.status") + ":",
                  placeholder: _vm.$t(
                    "application.listing.selectStatusesToFilter"
                  ),
                  data: Object.keys(_vm.statuses),
                },
                on: { change: _vm.handleStatusSelect },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }